export enum RemoveCommandState {
	CREATED = 'created',
	FAILED = 'failed',
	DONE = 'done',
	ATTEMPTED = 'attempted',
}
